// extracted by mini-css-extract-plugin
export default {"form_group":"SearchInput_form_group__TIII6","label":"SearchInput_label__bnp53","input_box":"SearchInput_input_box__t3B9J"};